import { toUpper } from "lodash"
import useResource from "hooks/resources"
import { useAccountAlias } from "resources/account"

export const RESOURCE_LIST_QUERY = `
query($resourceType: ResourceType){
  resources(type: $resourceType) {
    id
    name
    type
    alias
    description
    permissionLevel
    ... on TemplateResourceMeta {
      templateType
    }
  }
}`

export function useResourcesList(resourceType) {
  return useResource({
    resource: `resourcesList-${resourceType}`,
    url: () => {
      if (!resourceType) {
        return null
      }
      return {
        id: `resourcesList-${resourceType}`,
        query: RESOURCE_LIST_QUERY,
        variables: { resourceType: toUpper(resourceType) },
      }
    },
  }, "resources")
}

export function useResourceMetadata(modelId, resourceId, resourceType) {
  const accountAlias = useAccountAlias()
  return useResource({
    resource: "resourceMetadata",
    url: () => {
      if (!modelId || !resourceId || !resourceType) {
        return null
      }
      return `/api/${accountAlias}/m/${modelId}/r/${resourceType}/${resourceId}`
    },
  }, "resourceMetadata")
}
